const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Overview Assignments Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.controller('overviewAssignmentsController', ['Assignments', 'Features', 'AccessHelper', function (Assignments, Features, AccessHelper) {
  var self = this;
  self.assignmentTemplates = Features.flags().enable_assignment_templates;
  self.newTemplate = false;
  self.createdTemplate = false;
  self.assignmentsRefresh = false;

  self.circleStats = {
    totalAssignments: 0,
    inprogressAssignments: 0,
    failedAssignments: 0,
    passedAssignments: 0
  };

  self.tabAccess = {
    assignments_create: AccessHelper.isAllowed(['admin', 'assignments', 'create'], null, ['admin', 'creator', 'manager']),
  };

  self.activeTab = 'assignments';

  self.goTo = function(tab) {
    if (!self.assignmentTemplates && tab === 'assignments') {
      return;
    }
    // Opportunity for verifying current state and future profile validations
    self.activeTab = tab;
  };

  self.createTemplate = function() {
    self.newTemplate = true;
  };

  Assignments.overviewStats().$promise
  .then(function(results) {
    Object.assign(self.circleStats, results);
    for (var key in self.circleStats) {
      if (self.circleStats[key] < 0) {
        self.circleStats[key] = 0;
      }
    }
  }).catch(function(error) {
    console.log('error in stats: ', error);
  });

}]);